import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Columns, Config, DefaultConfig, API, APIDefinition } from 'ngx-easy-table';
import {IntranetoldService} from './../../../api/intranetold.service';
import {NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { StockComercialDetalleItemBodegaComponent } from './detalleArticuloBodega';
import { DetalleItemService } from 'src/app/api/detalleItem.service';
import { variableGlobal } from 'src/app/global.enum';


@Component({
  selector: 'app-detalleItem',
  templateUrl: './detalleItem.html',
  styleUrls: ['./detalleItem.css']
})

export class DetalleItemComponent implements OnInit {
  
  constructor(
    public activeModal: NgbActiveModal,
    private _detalleItemService: DetalleItemService,
    private modalService: NgbModal,
    private _api:IntranetoldService,

  ){

  }

  Item: any;
  public configuration: Config;
  public columns: Columns[];
  @ViewChild('frmItemCode', { static: true }) frmItemCode: TemplateRef<any>;
  @ViewChild('frmDisponibleVenta', { static: true }) frmDisponibleVenta: TemplateRef<any>;
  @ViewChild('frmPrice', { static: true }) frmPrice: TemplateRef<any>;
  data:any = [];
  detalles:any;
  bodegas:any;
  bodegaSelecciona:any;
  objetoApi:any;
  dataTabla:any;
  async ngOnInit(): Promise<void> {

    

    this.objetoApi = 
    [
      {
        "Code": this.Item.ItemCode
      }
    ]
    await this.cargaInicial();

    this.bodegaSelecciona = this.detalles.ToWH;

  }

  async cargaInicial() {
    this.columns = [
        { key: 'Code', title: "Codigo", cellTemplate: this.frmItemCode },
        { key: 'ItemName', title: 'Descripción' },
        { key: '', title: 'Stock disponible', cssClass: { includeHeader: true, name: 'green-background' }, cellTemplate: this.frmDisponibleVenta },
        { key: 'Quantity', title: 'Cantidad Requerida' },
    ];

    this.configuration = {
        ...DefaultConfig,
        searchEnabled: true,
        detailsTemplate: true,
        paginationRangeEnabled: false,
        horizontalScroll: true,
        resizeColumn: false,
        fixedColumnWidth: true,
    };

    let res: any = await this._detalleItemService.obtieneListaMaterialVirtual(this.objetoApi);
    
    this.detalles = res.resultado[0];

    for (const item of this.detalles.iTT1) {
        var data: any = await this._api.getQueryAll();
        var query: string = "";
        await data.objeto.forEach(element => {
            if (element.NOMBRE == "consultaStockDisponible") {
                query = element.CONSULTA;
            }
        });
        query = query.replace('{ItemCode}', item.Code);
        
        
        var datos: any = await this._api.GetNotFileQuery(query);
        
        item.StockDisponible = datos.objeto[0].StockDisponible;
    }

    this.dataTabla = [...this.detalles.iTT1]

    var data: any = await this._api.getQueryAll();
    var query: string = "";
    await data.objeto.forEach(element => {
        if (element.NOMBRE == "OWHS") { //stockComercial
            query = element.CONSULTA;
        }
    });
    var datos: any = await this._api.GetNotFileQuery(query);
    this.bodegas = datos.objeto;
    

    

    
    
    this.detalles.OnHandVirtual = await this.calcularProductosMaestros(this.detalles.iTT1);
    
}

async calcularProductosMaestros(stockSubProductos) {
  if (!stockSubProductos || stockSubProductos.length === 0) {
      return 0; // Retorna 0 si stockSubProductos está vacío
  }

  let stockMaximo = Infinity;

  for (const item of stockSubProductos) {
      const stockDisponible = Math.floor(item.StockDisponible / item.Quantity);
      if (!isNaN(stockDisponible) && stockDisponible < stockMaximo) {
          stockMaximo = stockDisponible;
      }
  }

  return stockMaximo === Infinity ? 0 : stockMaximo;
}





  cerrar() {
    this.activeModal.close();
  }

  abrirListaItem(item)
  {
    this._detalleItemService.abrirDetalleItem(item);
  }

  AbrirDetalleItem(item)
  {
    let ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false,
      size:"xl",
      modalDialogClass:variableGlobal.CLASS_MODAL_BG
    };
    const modalRef = this.modalService.open(StockComercialDetalleItemBodegaComponent, ngbModalOptions);
    modalRef.componentInstance.ItemCode = item.ItemCode;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then((data) => {


    }, (reason) => {
      //this.editar(item);
    });
  }

  cambiaBodega(){
    this.objetoApi = [
      {
        "Code": this.Item.ItemCode,
        "ToWH": this.bodegaSelecciona
      }
    ]
    this.cargaInicial();
  }

  
}